import React from 'react';
import PropTypes from 'prop-types';

// helpers
import get from 'lodash.get';
import tracking from 'dibs-tracking';

// constants
const MIN_ITEM_COUNT = 2;

function trackAttributeClick(label) {
    tracking.trackEvent({
        label,
        category: 'product',
        action: 'attribute click',
    });
}

function AttributeLink({ categories, attribute }) {
    const hasCategories = !!get(categories, 'length');
    const attributeKey = get(attribute, 'attributeKey');
    const attributeValue = get(attribute, 'option.name');
    const hasMinItems = get(attribute, 'publishedItemsCount') >= MIN_ITEM_COUNT;

    let attributeUrl;
    if (hasCategories && hasMinItems) {
        const category = categories.find(cat => get(cat, 'precedence') === 1);

        const attributeUrlLabel = get(attribute, 'option.urlLabel');
        const categoryBrowseUrl = get(category, 'category.browseUrl');

        if (categoryBrowseUrl && attributeKey && attributeUrlLabel) {
            attributeUrl = `${categoryBrowseUrl}${attributeKey}/${attributeUrlLabel}/`;
        }
    }

    if (!attributeUrl) {
        return <span>{attributeValue}</span>;
    }

    return (
        <a href={attributeUrl} onClick={() => trackAttributeClick(attributeKey)}>
            {attributeValue}
        </a>
    );
}

AttributeLink.propTypes = {
    categories: PropTypes.arrayOf(
        PropTypes.shape({
            precedence: PropTypes.number,
            category: PropTypes.shape({
                browseUrl: PropTypes.string,
            }),
        })
    ),
    attribute: PropTypes.shape({
        attributeKey: PropTypes.string.isRequired,
        publishedItemsCount: PropTypes.number.isRequired,
        option: PropTypes.shape({
            name: PropTypes.string.isRequired,
            urlLabel: PropTypes.string.isRequired,
        }).isRequired,
    }),
};

export default AttributeLink;
